<template>
  <div class="playlist">
    <PlaylistCard
      v-bind="{
        playlist,
        isOpen,
        isSonarPlaylist,
      }"
      @openContent="toggleContent"
    />
    <PlaylistContent
      v-if="isOpen"
      :playlistId="playlist.id"
      :loading="isLoading"
      :isSonarPlaylist="isSonarPlaylist"
      @close-content="toggleContent"
      @go-to-assessment="goToAssessmentHandler"
    />
    <SonarMobileAlert v-if="showMobileAlertModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PlaylistCard from './PlaylistCard.vue'
import PlaylistContent from './PlaylistContent.vue'
import CONSTANTS from '@/constants'
import { assessmentHandler } from '@/sonar/helpers/mixins'
import { playlistCommons } from '@/helpers/mixins'
import SonarMobileAlert from '@/sonar/components/SonarMobileAlert.vue'

export default {
  name: 'Playlist',
  components: {
    PlaylistCard,
    PlaylistContent,
    SonarMobileAlert,
  },
  mixins: [assessmentHandler, playlistCommons],
  props: {
    playlist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      showMobileAlertModal: 'sonar/showStartAssessmentModal',
    }),
    isSonarPlaylist() {
      const { SONAR_RECOMMENDED, SONAR_GOAL } = CONSTANTS.PLAYLIST_TYPES
      return [SONAR_RECOMMENDED, SONAR_GOAL].includes(this.playlist.type)
    },
    isSonarRoute() {
      return this.$route.name === CONSTANTS.SONAR.ROUTES.HOME
    },
  },
  methods: {
    ...mapActions('sonar', ['getAssessments']),
    async toggleContent() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.isLoading = true
        try {
          await this.fetchPlaylist()
        } catch (e) {
          this.isOpen = false
        } finally {
          this.isLoading = false
        }
      } else {
        const body = document.querySelector('body')
        body.classList.remove('modal-open')
        return this.isSonarRoute
          ? this.$parent.$emit('update-playlists')
          : this.$emit('update-playlists')
      }
    },
    goToAssessmentHandler(assessment_id) {
      this.goToAssessment(assessment_id)
    },
  },
}
</script>
